import { SelectedPurposeOfUseOrContact } from '../../../common/enums.js';
import { createSupportCaseAuthenticated } from '../../../common/fetch.js';
import { removeOmaLaiteLaskuSupportCase } from '../../EoeSubscriptionDetails/eppSubscriptionUtils.js';
import type { PurposeOfUseOrContact } from '../../../common/types/subscription.js';
import type { Subscription } from '../../../generated/api/subscription.js';
import type { BillingAccountAndUserInfoFormValues } from '../subscriptionDetailsUtils.js';

const getSelectedContactId = (values: BillingAccountAndUserInfoFormValues): string | undefined =>
  values.selected === SelectedPurposeOfUseOrContact.CONTACT ? values.contactId : undefined;

export const isSubscriptionUserChanged = (
  purposeOfUseOrContact: PurposeOfUseOrContact,
  values: BillingAccountAndUserInfoFormValues
): boolean => getSelectedContactId(values) !== purposeOfUseOrContact.contactId;

export const isOmaLaiteLaskuUserChange = (
  subscription: Subscription,
  purposeOfUseOrContact: PurposeOfUseOrContact,
  values: BillingAccountAndUserInfoFormValues,
  isChangeContractOwner: boolean
): boolean =>
  Boolean(subscription.details?.device?.omaLaiteLasku) &&
  !isChangeContractOwner &&
  isSubscriptionUserChanged(purposeOfUseOrContact, values);

export const createOmaLaiteLaskuRemovalSupportCase = async (
  subscription: Subscription,
  billingAccountDisplayId: string | undefined,
  mdmId: string
): Promise<void> => {
  await createSupportCaseAuthenticated(
    removeOmaLaiteLaskuSupportCase(
      subscription.subscriptionId,
      subscription.subscriptionDisplayId || '',
      billingAccountDisplayId || ''
    ),
    mdmId
  );
};
